import React, { useEffect } from 'react';

import { useParams } from 'react-router-dom';

import useHashmapConverter from 'hooks/useHashmapConverter';

import { IContract, IProject, useProjectTreeStore } from 'store/projectContract.store';

import { useQueryGetVersionsList } from 'api/queries/getVersionsList.query';

import { ProjectTree } from 'components/common/TreeProgramFilter/ProjectTree/ProjectTree';
import { VersionSelect } from 'components/common/TreeProgramFilter/VersionSelect/VersionSelect';

import classes from './treeProgramTopHeader.module.scss';

interface Props {
    children?: React.ReactNode;
    versionSelectorEnabled?: boolean;
    showAll?: boolean;
    isDisabled?: boolean;
    callback?: (project: IProject | null, contract: IContract | null) => void;
}

export const TreeProgramTopHeader = ({
    children,
    versionSelectorEnabled = true,
    showAll = false,
    isDisabled = false,
    callback,
}: Props) => {
    const { contract, project, update } = useProjectTreeStore();

    const { id } = useParams<{ id: string }>();
    const { versionList } = useHashmapConverter(id);

    useEffect(() => {
        if (versionList.length > 0) {
            update({
                project: {
                    id: versionList[0].projectId,
                    title: versionList[0].projectName,
                    uuid: versionList[0].projectUuid,
                },
                contract: {
                    id: versionList[0].contractId,
                    title: versionList[0].contractName,
                    uuid: versionList[0].contractUuid,
                },
            });
        }
    }, [versionList]);

    const { data: versionsListData } = useQueryGetVersionsList({
        projectId: project?.id,
        contractId: contract?.id,
    });

    return (
        <div data-testid={'program-top-header'} className={classes.treeProgramTopHeader}>
            <div data-testid={'header-content'} className={classes.headerContent}>
                <ProjectTree isAllOption={showAll} callback={callback} isDisabled={isDisabled} />

                {versionSelectorEnabled && versionsListData && <VersionSelect versionsList={versionsListData} />}

                {children && (
                    <div data-testid={'actions'} className={classes.actions}>
                        {children}
                    </div>
                )}
            </div>
        </div>
    );
};
